export const UserRole = {
    Owner: "Owner",
  }